

//import './App.css';
import { XTextWrapper } from 'lbp-components';
import React from 'react'
import NavBar from './NavBar';
import Footer from './Footer';
import {Route, Routes, useLocation, useNavigate} from 'react-router-dom';
//import './XTextWrapper.css'; // Import the CSS file
import 'lbp-components/style.css';
//import './lascasas.css';
//import './kmacademy.css'
import './scta.css';
import Home from './Home';
import About from './About';
//import 'bootstrap/dist/css/bootstrap.min.css';

/* 

config would include start resource for text
theme colors
nav bar link
logo

*/

const siteConfigs = {lascasas:{
  title: "Las Casas Opera Omnia",
  subtitle: "Explore the works of Bartolomé de las Casas",
  text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
  entryResource: "http://scta.info/resource/per-bdlcbd",
  styleSheet: "lascasas.css",
  memberSupport: {title:"Societas Lascasiana",url:"https://www.lascasianstudies.org"},
  componentExcludeList: ["chat", "comments"]
},
kmacademy:{
  title: "Kyiv-Mohyla Academy",
  subtitle: "Explore the works of the Kyiv-Mohyla Academy",
  text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
  entryResource: "http://scta.info/resource/kygivmohylaacademy",
},
scta: {
  title: "The SCTA Reading Room",
  subtitle: "A site for reading, viewing, and studying the scholastic tradition",
  text: "",
  entryResource: "http://scta.info/resource/scta",
  styleSheet: "scta.css",
  navBar: {
    "Texts": "http://scta.info/resource/scta",
    "People": "http://scta.info/resource/person",
    "Codices": "http://scta.info/resource/codex",
    "Expression Types": "http://scta.info/resource/expressionType",
  },
  componentExcludeList: ["chat"],
  sideWindowOpenWidthHeight: "middle"
}
}
//const siteConfig = siteConfigs.kmacademy;
const variant = process.env.REACT_APP_VARIANT || 'lascasas';
const siteConfig = siteConfigs[variant];

// Dynamically require the CSS file based on the variant
// this only works in development 
// requires static import in production see above declarations

// if (variant === 'lascasas') {
//   require('./lascasas.css');
// } else if (variant === 'scta') {
//   require('./scta.css');
// } else if (variant === 'kmacademy') {
//   require('./kmacademy.css');
// }

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  
  const queryParams = new URLSearchParams(location.search);
  const resParam = queryParams.get('resourceid') || siteConfig.entryResource;
 const handleResourceChange = (newRes) => {
    queryParams.set('resourceid', newRes);
    const humanReadableQueryString = Array.from(queryParams.entries())
      .map(([key, value]) => `${key}=${decodeURIComponent(value)}`)
      .join('&');
    navigate(`${location.pathname}?${humanReadableQueryString}`);
  };

  const excludeList = siteConfig.componentExcludeList || []

  return (
    
    <div className="main" style={{"marginTop": "75px"}}>
      <NavBar title={siteConfig.title} entryResource={siteConfig.entryResource} navBarItems={siteConfig.navBar}/>
      <Routes>
      <Route path="/" element={<Home title={siteConfig.title} subtitle={siteConfig.subtitle} text={siteConfig.text} entryResource={siteConfig.entryResource}/>} />
      <Route path="/about" element={<About/>} />
        <Route path="/text" element={<XTextWrapper sideWindowOpenWidthHeight={siteConfig.sideWindowOpenWidthHeight} resourceid={resParam} handleResourceChange={handleResourceChange} excludeList={excludeList} theme="theme-light" customClassName="custom-text-wrapper" />} />
        <Route path="/res" element={<XTextWrapper sideWindowOpenWidthHeight={siteConfig.sideWindowOpenWidthHeight} resourceid={resParam} handleResourceChange={handleResourceChange} excludeList={excludeList} theme="theme-light" customClassName="custom-text-wrapper" />} />
      </Routes>
      {/* <Footer member={siteConfig?.memberSupport}/> */}
      
      
    </div>
  );
}

export default App;
